import { Venue } from "@greeter/core";
import { useIonViewDidEnter } from "@ionic/react";
import React, { useEffect, useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { bundleKeys, venueKeys } from "@greeter-venue/api/QueryKeys";
import { VenuePage } from "./VenuePage";
import { useUpcomingGreeterEventsQuery } from "@greeter-venue/api/Hooks";
import { useGreeterVenueApi, useNow } from "@greeter/matter";
import { useFeatureFlags } from "../../contexts/FeatureFlagsProvider";
import { useLoading } from "@greeter/loading";

function dependsOn(...deps: any[]) {
  for (let i = 0, l = deps.length; i < l; i++) {
    const d = deps[i];
    if (!d) return false;
  }

  return true;
}

export const VenuePageApiHandler: React.FC = () => {
  const featureFlags = useFeatureFlags();
  const { api: venueApi } = useGreeterVenueApi();

  const venueQuery = useQuery({
    queryKey: venueKeys.self(),
    queryFn: async () => await venueApi.fetchVenue(),
  });

  const queryClient = useQueryClient();

  const bundlesQuery = useQuery({
    queryKey: bundleKeys.all(),
    async queryFn() {
      try {
        const bundles = await venueApi.fetchBundles({});
        for (const b of bundles) {
          queryClient.setQueryData(bundleKeys.detail(b.id), b);
        }
        return bundles;
      } catch (error) {
        console.warn(`Failed with error`, error);
        return [];
      }
    },
    enabled: dependsOn(venueQuery.data),
  });

  const now = useNow();
  const eventsQuery = useUpcomingGreeterEventsQuery(now);

  const isStripePaymentAccountCompleteQuery = useQuery({
    queryKey: ["is-stripe-payment-account-complete"],
    queryFn: async () => await venueApi.fetchStripeIsPaymentAccountComplete(),
    enabled: dependsOn(venueQuery.data),
  });

  useEffect(() => {
    bundlesQuery.refetch();
    eventsQuery.refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [venueQuery.data]);

  useIonViewDidEnter(() => {
    bundlesQuery.refetch();
    isStripePaymentAccountCompleteQuery.refetch();
  });

  const { waitFor } = useLoading();

  return (
    <VenuePage
      wardrobeEnabled={featureFlags["wardrobe.v1.venue"]}
      themes={venueQuery.data?.themes ?? []}
      products={bundlesQuery.data ?? []}
      events={eventsQuery.data ?? []}
      venue={venueQuery.data ?? Venue.createDefault()}
      isStripePaymentAccountComplete={isStripePaymentAccountCompleteQuery.data}
      onCompleteStripePaymentAccount={async () => {
        const onboardingLink = await waitFor(
          venueApi.fetchStripeOnboardingLink({
            // TDOO: As of right now custom schemes dont work.
            //       They are not valid scheme according to Stripe
            // redirectUrl: `greeter://greeter.guest${location.pathname}`,
            // redirectUrl: `greeter://greeter.guest${location.pathname}`,
            refreshUrl: `https://www.greeter.dk`,
            redirectUrl: `https://www.greeter.dk`,
          }),
          "Henter Stripe login link..."
        );

        // For some reason AppLauncher is not working?
        // await AppLauncher.openUrl({ url: onboardingLink });
        window.location.href = onboardingLink;
      }}
    />
  );
};
